
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// Məhsul əlavə etmək
export const add_product = createAsyncThunk(
    'product/add_product',
    async (product, { rejectWithValue, fulfillWithValue ,getState}) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.post(`/product-add`, product, {withCredentials: true});
            return fulfillWithValue(data);
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue({ error: 'An unexpected error occurred.' });
            }
        }
    }
);

// Məhsulları əldə etmək (çoxlu)
export const get_products = createAsyncThunk(
    'product/get_products',
    async ({ parPage, page, searchValue, discounted }, { rejectWithValue, fulfillWithValue, getState }) => {
                // const token = getState().auth.token
                // const config = {
                //     headers: {
                //         'Authorization': `Bearer ${token}`
                //     }
                // }
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage })
            if (discounted) params.append('discounted', 'true')
            const { data } = await axios.get(`${api_url}/api/products-get?${params.toString()}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// TEK MƏHSUL əldə etmək (ən vacib!)
export const get_product = createAsyncThunk(
    'product/get_product',
    async (productId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/product-get/${productId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsul tapılmadı' })
        }
    }
)






export const update_product = createAsyncThunk(
    'product/updateProduct',
    async (product, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.post(`/product-update`, product, { withCredentials: true })
            console.log(data);
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const product_image_update = createAsyncThunk(
    'product/product_image_update',
    async ({ oldImage, newImage, productId }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const formData = new FormData()
            formData.append('oldImage', oldImage)
            formData.append('newImage', newImage)
            formData.append('productId', productId)
            const { data } = await api.post(`/product-image-update`, formData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const delete_product = createAsyncThunk(
    'product/delete_product',
    async (productId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`/seller/product/${productId}`, { withCredentials: true })
            return fulfillWithValue({ ...data, productId })
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsul silinmədi' })
        }
    }
)


export const productReducer = createSlice({
    name: 'product',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        products: [],
        product: '', // ← TEK MƏHSUL ÜÇÜN
        totalProduct: 0,
        activeDopingProducts: [],
        dopingLoader: false,
         dopingPrices: null
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder
            // Add Product
            .addCase(add_product.pending, (state) => {
                state.loader = true
            })
            .addCase(add_product.rejected, (state, { payload }) => {
                state.loader = false
                console.log('redux error ', payload);
                state.errorMessage = payload.error
            })
            .addCase(add_product.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })

            // Get Products (çoxlu)
            .addCase(get_products.fulfilled, (state, { payload }) => {
                state.totalProduct = paginationTotal(payload, 'totalProduct')
                state.products = payload.products || payload.data || []
            })

            // Get Product (TEK MƏHSUL) - ƏN VACİB!
            .addCase(get_product.pending, (state) => {
                console.log('📦 GET_PRODUCT pending...');
                state.loader = true
                state.product = '' // Reset product
            })
            // .addCase(get_product.fulfilled, (state, { payload }) => {
            //     console.log('✅ GET_PRODUCT fulfilled:', payload);
            //     state.loader = false
            //     state.product = payload.product // ← BURA DİQQƏT!
            // })
            .addCase(get_product.fulfilled, (state, action) => {
                console.log('✅ GET_PRODUCT fulfilled - FULL ACTION:', action);
                console.log('✅ Payload:', action.payload);
                console.log('✅ Product data:', action.payload?.product);
                
                state.loader = false
                state.product = action.payload?.product || null
                state.errorMessage = ''
})
            .addCase(get_product.rejected, (state, { payload }) => {
                console.log('❌ GET_PRODUCT rejected:', payload);
                state.loader = false
                state.errorMessage = payload?.error || 'Məhsul tapılmadı'
            })

            // Update Product
            .addCase(update_product.pending, (state) => {
                state.loader = true
            })
            .addCase(update_product.rejected, (state, { payload }) => {
                state.loader = false
                console.log('redux error ', payload);
                state.errorMessage = payload.error
            })
            .addCase(update_product.fulfilled, (state, { payload }) => {
                state.loader = false
                state.product = payload.product
                state.successMessage = payload.message
            })

            // Product Image Update
            .addCase(product_image_update.fulfilled, (state, { payload }) => {
                state.product = payload.product
                state.successMessage = payload.message
            })

            .addCase(delete_product.pending, (state) => {
                state.loader = true
            })
            .addCase(delete_product.fulfilled, (state, { payload }) => {
                state.loader = false
                state.products = state.products.filter(product => product._id !== payload.productId)
                state.totalProduct = Math.max(0, state.totalProduct - 1)
                state.successMessage = payload.message
            })
            .addCase(delete_product.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || payload?.error || 'Məhsul silinmədi'
            })

           
    }
})

export const { messageClear } = productReducer.actions
export default productReducer.reducer
